export default "__VITE_ASSET__38a6a546__"